import tw from "twin.macro";
export const PrimaryButton = tw.button`px-8 py-3 lg:mr-10 font-bold rounded-full bg-primary-500 text-gray-100 hocus:bg-primary-700 hocus:text-gray-200 hocus:shadow-outline hocus:outline-none transition duration-300`;
